export const NoAuthWebUrl = {
  login: '/login',
  login_token: '/login/:token',
};
